import{
  GenerateRandomId,
  chromeExtension,
  productID,
  extensionName,
  reqEventName,
  respEventName
} from './const/cryptokit.js'


import { checkExtension } from './const/browser.js'
import { SendMsg } from './sendMsg/index'
// 连接扩展
export const connect = ()=> {
  return checkExtension()
  .then((res)=> {
      return SendMsg({action: "connect", host: productID})
  })
  .then((res)=> {
      return SendMsg({action: "checkHost"})
  })
}

// 断开连接
export const disConnect = ()=> {
  return SendMsg({action: 'disconnect', host: productID})
}

export const selectCertificate = (strSubjectDNFilter = '', strIssuerDNFilter = '', strSerialNo = '', strCSPList = '')=> {
  let request = {
    action: "invoke",
    funcInfo: {
      function: 'SelectCertificate',
      params: [strSubjectDNFilter, strIssuerDNFilter, strSerialNo, strCSPList],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const getVersion = ()=> {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'GetVersion',
      params:[],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

// 获取 口令 "123", "SHA-1" ,true
export const signMsgPKCS7 = (strSource = '123', strSelectedAlg = 'SHA-1', bAttached = true)=> {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'SignMsgPKCS7',
      params:[strSource, strSelectedAlg, bAttached],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const signHashMsgPKCS7Detached = (strSource, strSelectedAlg)=> {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'signHashMsgPKCS7Detached',
      params:[strSource, strSelectedAlg],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const getSignCertInfo = (strInfoType)=> {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'GetSignCertInfo',
      params:[strInfoType],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_SetCSPInfo = (lKeyLength, bstrCSPName) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_SetCSPInfo',
      params:[lKeyLength, bstrCSPName],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_SetKeyAlgorithm = (bstrKeyAlgorithm) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_SetKeyAlgorithm',
      params:[bstrKeyAlgorithm],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

export const CFCA_ImportSignCert = (lCertType, bstrSignCert, bstrContainerName) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_ImportSignCert',
      params:[lCertType, bstrSignCert, bstrContainerName],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

// 获取取得当前密钥对的密钥容器名称
export const CFCA_GetContainer = () => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_GetContainer',
      params:[],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}

// 生成证书申请消息（符合PKCS#10标准），用于申请签名证书或双证
export const CFCA_PKCS10CertRequisition = (bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags) => {
  let request = {
    action: 'invoke',
    funcInfo: {
      function: 'CFCA_PKCS10CertRequisition',
      params:[bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags],
      randomId: GenerateRandomId()
    }
  }
  return SendMsg(request)
}




// WEBPACK FOOTER //
// ./apps/cfca/cryptokit/api.js